import { SousDispositifLibelle as SousDispositifAFLib } from '@/features/domaine/types/opco/Demande/AF'
import { SousDispositifLibelle as SousDispositifCPROLib } from '@/features/domaine/types/opco/Demande/CPRO'
import { SousDispositifLibelle as SousDispositifPROALib } from '@/features/domaine/types/opco/Demande/PROA'


export const DispositifSousDipositif = {
  AF: SousDispositifAFLib,
  CAPP: null,
  CPRO: SousDispositifCPROLib,
  PROA: SousDispositifPROALib
} as const

